import { Button, DialogProps, Typography } from '@mui/material';

import BaseDialog from '@/components/shared/Dialog/BaseDialog';
import { useRevokeApiKey } from '@/hooks/useRevokeApiKey';
import theme from '@/theme';

interface RevokeApiKeyDialogProps {
  open: boolean;
  onClose: DialogProps['onClose'];
  organizationId: number;
  keyId: number;
  isRefetching: boolean;
}

function RevokeApiKeyDialog({ open, onClose, organizationId, keyId, isRefetching }: RevokeApiKeyDialogProps) {
  const { revokeApiKey, isPending, error } = useRevokeApiKey(organizationId);

  const handleRevoke = async () => {
    await revokeApiKey(keyId);
    onClose?.({}, 'backdropClick');
  };

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title='Revoke API Key'
      hasCloseButton
      footer={
        <>
          <Button onClick={(e) => onClose?.(e, 'backdropClick')} disabled={isPending}>
            Cancel
          </Button>
          <Button variant='contained' onClick={handleRevoke} loading={isPending || isRefetching} disabled={isPending || isRefetching}>
            Revoke Key
          </Button>
        </>
      }
      alert={{
        isVisible: !!error,
        severity: 'error',
        alertMessage: error ? error : '',
      }}
    >
      <Typography sx={{ ...theme.hhglobal.typography.body.large }}>
        Are you sure you want to revoke the API key for Hub Catalog? This action cannot be undone and any integrations using this key will
        stop working immediately.
      </Typography>
    </BaseDialog>
  );
}

export default RevokeApiKeyDialog;
